import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt, faAngleDown, faAngleUp, faFilePdf, faMinusCircle, faStar } from '@fortawesome/free-solid-svg-icons'
import { getShowDocList, getToggleDocument, getActivePane } from '../../../reducers/data'
import './DetailsRow.css'
import { setSort, toggleDocumentForm } from '../../../actions/data'
library.add(faExternalLinkAlt, faAngleDown, faAngleUp, faMinusCircle, faFilePdf, faStar)

class DetailsRow extends Component {
  toggleDocumentDetails(ticker) {
    this.props.toggleDocumentForm(ticker)
  }

  formatThousands(number) {
    return number !== null ? parseFloat(number).toFixed(2) / 1000 : '-'
  }

  formatDecimal(number) {
    return number !== null ? parseFloat(number).toFixed(2) : '-'
  }

  formatCurrency(fund, fundType) {
    let number = 0
    let currency = fund.listingCCY
    let decimals = true

    if (fundType === 'NAV') {
      number = fund.NAV
    } else if (fundType === 'AUM') {
      number = fund.AUM
      decimals = false
      if (fund.fundStructureID === '2') {
        currency = fund.fundCurrency
      }
    }

    const options = { style: 'currency', currency: '' }
    options.currency = currency
    if (!decimals) {
      options.maximumFractionDigits = 0
      options.minimumFractionDigits = 0
    }
    const numberFormat2 = new Intl.NumberFormat('en-US', options)
    return number !== null ? numberFormat2.format(parseFloat(number)) : '-'
  }

  formatPercent(number) {
    return number !== null ? parseFloat(number * 100).toFixed(2) + '%' : '-'
  }

  formatDate(string) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(string).toLocaleDateString([], options)
  }

  renderStars(param) {
    switch (param) {
      case 5:
        return (
          <span style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
          </span>
        )
      case 4:
        return (
          <span style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
            <FontAwesomeIcon className='fa' icon='star' />
          </span>
        )
      default:
    }
  }

  render() {
    const { fund, showDocList, toggleDocument } = this.props

    function setStyle(ticker) {
      if (showDocList === ticker && toggleDocument === true) {
        return {
          background: '#ffffff',
          'border-bottom': 'white'
        }
      } else {
        return {
          background: '#ffffff'
        }
      }
    }

    if ((this.props.division === '1' || this.props.division === '3') && this.props.activePane === 'fund') {
      return (
        <Fragment>
          <tr style={setStyle(fund.bloombergTicker)}>
            {fund.url ? (
              <td width='250' className={'nameLink'}>
                <a href={fund.url} target='_new'>
                  {fund.displayName}
                </a>{' '}
              </td>
            ) : (
              <td width='250' className={'nameLink'}>
                {' '}
                {fund.displayName}
              </td>
            )}
            <td width='75' className={'tickerLink'}>
              <a href={fund.url} target='_new'>
                {fund.bloombergTicker}{' '}
              </a>
            </td>
            <td width='125' className={'textCenter'}>
              {fund.fundCategoryTier1}
            </td>
            <td width='120' className={'textCenter'}>
              {fund.fundCategoryTier2}{' '}
            </td>
            <td width='100' className={'textCenter'}>
              {fund.inceptionDt}
            </td>
            <td width='135' className={'textCenter'}>
              {this.formatPercent(fund.grossExpenseRatio)}
            </td>
            <td width='120' className={'textCenter'}>
              {this.formatPercent(fund.expenseRatio)}
            </td>
            <td width='115' className={'textCenter'}>
              {fund.AUM !== null ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }, { maximumSignificantDigits: 3 }).format(this.formatThousands(fund.AUM)) : '-'}
            </td>
            <td width='125' className={'textCenter'}>
              {this.formatPercent(fund.TTMYieldOrdIncome)}{' '}
            </td>
            {this.props.division === '1' && (
              <td width='105' className={'textRight'}>
                {' '}
                {new Intl.NumberFormat('en-US', { maximumSignificantDigits: 5 }).format(fund.volume)}
              </td>
            )}
          </tr>
        </Fragment>
      )
      //EU Combined
    } else if (this.props.isEU && this.props.isLeveraged === '-1' && this.props.activePane === 'fund') {
      return (
        <Fragment>
          <tr style={setStyle(fund.bloombergTicker)}>
            {fund.url ? (
              <td width='270' className={'nameLink'}>
                <a href={fund.url}>{fund.displayName}</a>{' '}
              </td>
            ) : (
              <td width='270' className={'nameLink'}>
                {' '}
                {fund.displayName}
              </td>
            )}
            <td width='90' className={'textCenter'}>
              {fund.exchangeTicker}
            </td>
            <td width='100' className={'textCenter'}>
              {fund.leverageFactor}
            </td>
            <td width='55' className={'textCenter'}>
              {this.formatPercent(fund.expenseRatio)}
            </td>
            <td width='105' className={'textCenter'}>
              {fund.baseCCY}
            </td>
            <td width='105' className={'textCenter'}>
              {fund.listingCCY}
            </td>
            <td width='115' className={'textCenter'}>
              {fund.useOfIncome}
            </td>
            <td width='50' className={'textCenter'}>
              {this.formatCurrency(fund, 'NAV')}
            </td>
            <td width='60' className={'textCenter'}>
              {this.formatPercent(fund.dailyChange)}
            </td>
            <td width='50' className={'textCenter'}>
              {this.formatCurrency(fund, 'AUM')}
            </td>
          </tr>
        </Fragment>
      )
    } else if ((this.props.division === '1' || this.props.division === '3') && this.props.activePane === 'document') {
      return (
        <Fragment>
          <tr style={setStyle(fund.bloombergTicker)}>
            {fund.url ? (
              <td width='350' className={'nameLink'}>
                <a href={fund.url} target='_new'>
                  {fund.displayName}
                </a>{' '}
              </td>
            ) : (
              <td width='350' className={'nameLink'}>
                {' '}
                {fund.displayName}{' '}
              </td>
            )}
            <td width='200' className={'tickerLink'}>
              <a href={fund.url} target='_new'>
                {fund.bloombergTicker}{' '}
              </a>
            </td>
            <td width='115' className={'textCenter'}>
              {new Intl.NumberFormat('en-US', { maximumSignificantDigits: 5 }).format(fund.SharesOutstanding)}
            </td>
            <td width='50' className={'textCenter'}>
              &nbsp;&nbsp;{this.formatDecimal(fund.NAV)}&nbsp;&nbsp;
            </td>
            {fund.IndexURL ? (
              <td width='140' className={'textCenter'}>
                <a href={fund.IndexURL} target='_new'>
                  {fund.relatedIndex}
                </a>{' '}
              </td>
            ) : (
              <td className={'textCenter'}>{fund.relatedIndex} </td>
            )}
            <td width='250' className={'docLink'}>
              {fund.FactsheetURL ? (
                <div>
                  <a href={fund.FactsheetURL} target='_new'>
                    {' '}
                    <span className='pdf-link'> {fund.bloombergTicker} Quarterly Factsheet </span>{' '}
                  </a>
                </div>
              ) : (
                ''
              )}
            </td>
            <td width='200' className={'tickerLink'}>
              {fund.ProspectusURL ? (
                <div>
                  <a href={fund.ProspectusURL} target='_new'>
                    {' '}
                    <span className='pdf-link'> {fund.bloombergTicker} Prospectus </span>{' '}
                  </a>{' '}
                </div>
              ) : (
                ''
              )}
            </td>
            <td width='375' className={'textLeft'}>
              {fund.collTextWaiverNoteList}
            </td>
          </tr>
        </Fragment>
      )

      //EU Combined
    } else if (this.props.isEU && this.props.isLeveraged === '-1' && this.props.activePane === 'document') {
      return (
        <Fragment>
          <tr style={setStyle(fund.bloombergTicker)}>
            {fund.url ? (
              <td width='370' className={'nameLink'}>
                <a href={fund.url}>{fund.displayName}</a>{' '}
              </td>
            ) : (
              <td width='370' className={'nameLink'}>
                {' '}
                {fund.displayName}
              </td>
            )}
            <td width='100' className={'textCenter'}>
              {fund.exchangeTicker}
            </td>

            {/* REMOVING TERMPORARILY FOR EU FACTSHEETS */}
            {/* <td width='350' className={'docLink'}>
              {fund.FactsheetURL ?
                <div><a href={fund.FactsheetURL} target='_new' > <span className='pdf-link' >   {fund.bloombergTicker} Factsheet </span>  </a></div> : ''
              }
            </td> */}
            <td width='350' className={'docLink'}>
              {fund.ProspectusURL ? (
                <div>
                  <a href={fund.ProspectusURL} target='_new'>
                    <span className='pdf-link'> {fund.bloombergTicker} Prospectus </span>{' '}
                  </a>{' '}
                </div>
              ) : (
                ''
              )}
            </td>
            <td width='250' className={'docLink'}>
              {fund.KIIDURL ? (
                <div>
                  <a href={fund.KIIDURL} target='_new'>
                    {' '}
                    <span className='pdf-link'>
                      {' '}
                      {fund.bloombergTicker} {fund.fundStructure === 'UCITS ETFs' ? 'KIID' : 'KID'}{' '}
                    </span>{' '}
                  </a>{' '}
                </div>
              ) : (
                ''
              )}
            </td>
          </tr>
        </Fragment>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    toggleDocument: getToggleDocument(state),
    showDocList: getShowDocList(state),
    activePane: getActivePane(state)
  }
}

export default connect(mapStateToProps, {
  setSort,
  toggleDocumentForm
})(DetailsRow)



// WEBPACK FOOTER //
// ./src/components/App/DetailsTable/DetailsRow.js